import React, { createContext, useContext, useState, useEffect } from "react";

const UserContext = createContext();

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within UserProvider");
  }
  return context;
};

export const UserProvider = ({ children }) => {
  const [authData, setAuthData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const savedAuthData = sessionStorage.getItem("authData");
      if (savedAuthData) {
        const parsedData = JSON.parse(savedAuthData);
        setAuthData(parsedData);
      }
    } catch (error) {
      console.error("Error parsing auth data:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const login = (fullAuthData) => {
    console.log("full auth data", fullAuthData);

    sessionStorage.setItem("authData", JSON.stringify(fullAuthData));
    setAuthData(fullAuthData);
  };

  const logout = () => {
    sessionStorage.removeItem("authData");
    setAuthData(null);
  };

  const value = {
    authData,
    token: authData?.access,
    userId: authData?.user_id,
    role: authData?.role,
    productionCenterId: authData?.production_center_id,
    refreshToken: authData?.refresh,
    loading,
    production_type: authData?.production_type,
    login,
    logout,
    isAuthenticated: !!authData,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
